import { ApiPath } from 'common/enums/http/api-path';
import type { ID, ResponseWithPagination } from 'common/types';
import type { TiresDisposals } from 'models/tires-disposals';
import { http } from 'services/http';

export const getTiresDisposalsApi = (params?: string) =>
  http.get<ResponseWithPagination<TiresDisposals>>(
    `${ApiPath.TIRES_DISPOSALS}${params || ''}`
  );

export const updateTiresDisposalsApi = ({
  id,
  body
}: {
  id: ID;
  body: Partial<Record<keyof TiresDisposals, unknown>>;
}) =>
  http.patch<TiresDisposals>({
    url: `${ApiPath.TIRES_DISPOSALS}${id}/`,
    options: {
      body
    }
  });
